import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 社区列表
interface GetCommunityListJson {
  created_at: string;
  device: string;
  appv: string;
  first_event: string;
  series: string;
  three_event: string;
  user_id: string;
  live_no: string;
  platform: string;
}
export const collect = (json: GetCommunityListJson): any =>
  http.httpPost({
    url: httpApi.collection.collect,
    json,
  });
